import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {UserCompanyModel} from '../../types';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch';
import baseUrl from '../baseUrl';
import {handleResponse} from '../handleResponse';

// Fetches the companies (internally "customers") the current user belongs to.
const useGetMyCompanies = (
    enabled = true
): UseQueryResult<UserCompanyModel[], Error> => {
    const authenticatedFetch = useCreateAuthenticatedFetch();

    return useQuery({
        queryKey: ['my-companies'],
        enabled,
        queryFn: async () => {
            const response = await authenticatedFetch(
                `${baseUrl}/api/auth/my-companies`
            );
            return handleResponse<UserCompanyModel[]>(response);
        }
    });
};

export default useGetMyCompanies;
